// @owners { team: patients-team }
import { type FertilityCycleMedicationType } from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import { isNil, omitBy } from 'lodash';
import { createSelector } from 'reselect';
import { getProgynyWizardEligiblePrescriptions } from './getProgynyWizardEligiblePrescriptions';
import { type EligiblePrescription } from '~shared/reducers/ui/progynyWizard';
import { type ReduxStateShared } from '~shared/types';

export type PrescriptionIDsByMedType = Partial<Record<FertilityCycleMedicationType, number>>;

export const getPrescriptionIDsByMedType: (state: ReduxStateShared) => PrescriptionIDsByMedType = createSelector(
  [getProgynyWizardEligiblePrescriptions],
  (eligiblePrescriptions: EligiblePrescription[] | null | undefined) => {
    const prescriptionIDsByMedType: Partial<Record<FertilityCycleMedicationType, number | null>> = {
      gonal_f: null,
      menopur: null,
      cetrotide: null,
      any: null,
    };
    eligiblePrescriptions?.forEach((rxMed) => {
      prescriptionIDsByMedType[rxMed.medicationType] = rxMed.prescriptionID;
    });

    return omitBy(prescriptionIDsByMedType, isNil);
  },
);

export type MedTypeByPrescriptionIDs = Record<string, FertilityCycleMedicationType>;

export const getMedTypeByPrescriptionID: (state: ReduxStateShared) => MedTypeByPrescriptionIDs = createSelector(
  [getProgynyWizardEligiblePrescriptions],
  (eligiblePrescriptions: EligiblePrescription[] | null | undefined) => {
    const medTypeByPrescriptionID = {};
    eligiblePrescriptions?.forEach((rxMed) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expression of type 'number' can't be used to index type... (Delete me to see the full error)
      medTypeByPrescriptionID[rxMed.prescriptionID] = rxMed.medicationType;
    });

    return medTypeByPrescriptionID;
  },
);
